<button type="submit" [disabled]="isLoading || disabled" *ngIf="isLoading" class="btn {{outlinedanger ?'btn-outline-danger' :'btn-custom'}} justify-content-center" [ngStyle]="{'width': width+ '%'}">
    <span class="spinner-border spinner-border-sm button-spinner" [ngClass]="{'outline-spinner-border' : outlinedanger}" role="status" aria-hidden="true"></span>
    <span class="mx-1">{{load_button_text}}</span>
</button>

<button type="submit" [disabled]="disabled" *ngIf="!isLoading" class="btn {{outlinedanger ?'btn-outline-danger' :'btn-custom'}} justify-content-center" [ngStyle]="{'width': width+ '%'}">
    {{button_text}}
</button>